import {Component, OnInit, HostListener} from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    currentYear: number;
    footerELement: HTMLElement;
    footerProperties: number;
    siteProfile:string;
    links: any;
    credits: any;
    constructor() {
        this.currentYear = new Date().getFullYear();
        this.siteProfile = environment.profile;
        this.links = environment.links;
        this.credits = environment.credits;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.foooterHeightHandler();
    }

    @HostListener('window:load', ['$event'])
    load() {
        this.foooterHeightHandler();
    }
    ngOnInit(): void {
        this.footerELement = document.querySelector('footer');
        this.foooterHeightHandler();
    }

    foooterHeightHandler() {
        if( this.footerELement){
            this.footerProperties = this.footerELement.getBoundingClientRect().height;
            document.querySelector('body').style.marginBottom = this.footerProperties + 'px';

        }
    }

}
